import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { useAdminAuth } from "@/context/AdminAuth";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail || "Login failed";
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md"
      >
        <Link to="/" className="block text-center mb-12">
          <span className="text-4xl font-brand text-[#EDEDED]">Swingle Events</span>
          <div className="font-mono-overline text-[#A3A3A3] mt-2">Admin Suite</div>
        </Link>
        <form
          onSubmit={handleSubmit}
          className="bg-[#111111] border border-[#2A2A2A] p-10"
          data-testid="admin-login-form"
        >
          <h1 className="text-3xl font-serif-display text-[#EDEDED] mb-2">Sign in</h1>
          <p className="text-sm text-[#A3A3A3] mb-8">Restricted to authorized hosts.</p>
          <div className="mb-5">
            <label className="font-mono-overline text-[#A3A3A3] block mb-2">Email</label>
            <input
              type="email"
              required
              data-testid="admin-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#0A0A0A] border border-[#2A2A2A] focus:border-[#e2a9f1] focus:outline-none px-4 py-3 text-[#EDEDED] rounded-sm"
              placeholder="admin@swingleevents.com"
            />
          </div>
          <div className="mb-8">
            <label className="font-mono-overline text-[#A3A3A3] block mb-2">Password</label>
            <input
              type="password"
              required
              data-testid="admin-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#0A0A0A] border border-[#2A2A2A] focus:border-[#e2a9f1] focus:outline-none px-4 py-3 text-[#EDEDED] rounded-sm"
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="w-full bg-[#e2a9f1] text-[#0A0A0A] font-semibold tracking-wide hover:bg-[#efc8f7] transition-colors duration-300 rounded-sm py-3 disabled:opacity-40"
          >
            {submitting ? "Signing in…" : "Enter"}
          </button>
        </form>
        <div className="text-center mt-8">
          <Link to="/" className="font-mono-overline text-[#A3A3A3] hover:text-[#e2a9f1]">
            ← Back to site
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
